<template>
  <div>
    <template>
      <aside class="sidebar" id="sidebar" >
      <div class="sidebar__boton" v-bind:class="{sidebar__boton___invisible:getMenuState}"  @click.prevent="updateStateMenu">
          <button class="boton">  
          </button>  
    
      </div>

      <div class="sidebar__menu" v-bind:class="{sidebar__menu___invisible:!getMenuState}"   >
          <div class="menu__titulo">
             <a href="http://cimogsys.com" class="titulo__item"> 
               <img class="titulo__img" src="../assets/img/cimogsys.png">
             </a>
             <div class="titulo__nombre">
                Bienvenid@  {{getVisitante}}
             </div>
          </div>
          <div class="menu__opciones" @click.prevent="updateStateMenu">
          

            <router-link  
              class="opciones__item"  
              v-bind:to="'/aplicacion/1'" 
              > <img class="item__imagen" src="../assets/img/institucion.svg">
              Institución
            </router-link>

            <router-link  
              class="opciones__item"  
              v-bind:to="'/aplicacion/2'" 
              >  <img class="item__imagen" src="../assets/img/administrativo.svg">
              Administrativas
            </router-link>

            <router-link  
              class="opciones__item"  
              v-bind:to="'/aplicacion/3'"
              > <img class="item__imagen" src="../assets/img/academico.svg">Facultades
            </router-link>
            
            <router-link  
              class="opciones__item"  
              v-bind:to="'/aplicacion/4'" 
              >  <img class="item__imagen" src="../assets/img/academico.svg">Carreras 
            </router-link>
            
            <router-link  
              class="opciones__item"  
              v-bind:to="'/aplicacion/5'" 
              > <img class="item__imagen" src="../assets/img/extension.svg">Extensiones
            </router-link>

            <router-link  
              class="opciones__item"  
              v-bind:to="'/aplicacion/6'" 
              > <img class="item__imagen" src="../assets/img/campus.svg">Infraestructura
            </router-link>

           
          </div>

          <div class="menu__redes">
            
             <a href="https://www.instagram.com/cimogsys/" class="redes__item"> 
                <img class="redes__img" src="../assets/img/ig.svg" height="23" width="24">
             </a>
             <a href="https://www.facebook.com/cimogsys" class="redes__item"> 
                <img class="redes__img" src="../assets/img/face.svg" height="23" width="24">
             </a>
             <a href="https://www.youtube.com/channel/UCzmXPIstvvY1zFzJI6Y_kpg" class="redes__item"> 
                <img class="redes__img" src="../assets/img/youtube.svg">
             </a>
             <a href="https://twitter.com/centro_cimogsys" class="redes__item"> 
                <img class="redes__img" src="../assets/img/twitter.svg" height="23" width="23">
             </a>
          </div>
      </div>
    </aside>
  </template>
</div>
</template>

<script>

import store from '../store'

export default {
    data () {
      return {

      }
    },
    mounted () {
    },
    computed: {
      getMenuState () {
        return store.state.menuState
      },
      getOption () {
        return store.state.optionActive
      },   
      getVisitante () {
        return store.state.visitante
      },      
    },

    methods:{
      updateStateMenu () {
        store.commit('UPDATEMENU')
      }
     
    }
   
};
</script>

 
<style  lang="scss" scoped src="../sass/menu.scss" scoped></style>





// WEBPACK FOOTER //
// src/components/menuLateral.vue